/** @deprecated */
export var arrowLeft = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 0l2 1.82L3.82 10 12 18.18 10 20 0 10 10 0z\"/></svg>";